import { featuredProducts } from '@/mocks/featured-products';

export default function ProductShowcase() {
  return (
    <section className="relative w-full bg-background-50 py-20 md:py-28">
      <div className="w-full max-w-[1200px] mx-auto px-6 md:px-10">
        {/* Section Header */}
        <div className="mb-14">
          <h2 className="text-3xl md:text-5xl font-heading font-semibold text-foreground-950 leading-tight">
            Produits Phares
            <br />
            Sélectionnés Pour Vous
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-[450px]">
            Découvrez notre sélection exclusive de produits populaires. Cliquez pour voir
            le catalogue complet sur Kaspreadsheet.
          </p>
        </div>

        {/* Product Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {featuredProducts.map((product) => (
            <a
              key={product.id}
              href={product.url}
              target="_blank"
              rel="noopener nofollow"
              className="group bg-background-50 border border-background-200/60 rounded-2xl overflow-hidden hover:border-primary-300/60 transition-all duration-300 cursor-pointer"
            >
              {/* Image */}
              <div className="relative w-full bg-background-100 overflow-hidden" style={{ height: `${product.imageHeight * 0.5}px`, maxHeight: '320px' }}>
                <img
                  src={product.image}
                  alt={`${product.name} - Hipobuy Spreadsheet`}
                  title={`${product.name} - Hipobuy Spreadsheet Catalogue`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-background-50/90 text-foreground-700 backdrop-blur-sm">
                    {product.category}
                  </span>
                </div>
              </div>

              {/* Info */}
              <div className="p-5 md:p-6">
                <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-2">
                  {product.name}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-4 line-clamp-2">
                  {product.description}
                </p>
                <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-500 group-hover:text-primary-600 transition-colors">
                  Voir sur Kaspreadsheet
                  <span className="w-4 h-4 flex items-center justify-center group-hover:translate-x-1 transition-transform">
                    <i className="ri-arrow-right-up-line"></i>
                  </span>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}